<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="订单ID">
                        <el-input v-model="params.oid" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable  class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="结算日期">
                        <el-date-picker v-model="params.createdAt" type="date" placeholder="选择结算日期"> </el-date-picker>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
                <el-button type="primary" @click="orderProfitTask" >执行结算</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" class="table-show-current" highlight-current-row>
            <el-table-column align="center" prop="id" label="结算ID" width="80"></el-table-column>
            <el-table-column align="center" prop="oid" label="订单ID" width="80"></el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span  v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{scope.row.memberAddress.slice(0,5) + "..." + scope.row.memberAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="orderCategory" label="订单类型" align="center" width="120">
                <template slot-scope="scope">{{scope.row.orderCategory == 1?"借贷池订单":"杠杆池订单"}}</template>
            </el-table-column>
            <el-table-column prop="orderAmount" label="订单金额" align="center">
                <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
            </el-table-column>
            <el-table-column align="center" label="结算日">
                <template slot-scope="scope">{{ formatDate2(new Date(scope.row.createdAt)) }}</template>
            </el-table-column>
            <el-table-column align="center" label="日利率">
                <template slot-scope="scope">{{ showApy(scope.row.dayRate) }}</template>
            </el-table-column>
            <el-table-column prop="total" align="center" label="收益总数"></el-table-column>
            <el-table-column prop="amount" align="center" label="收益实际到账"></el-table-column>
            <el-table-column prop="fee" align="center" label="手续费"></el-table-column>
            <el-table-column prop="createdAt" label="更新时间" align="center" width="150"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            params: {},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
        };
    },
    created() {
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            if(this.params.createdAt){
                this.params.createdAt = this.formatDate(new Date(this.params.createdAt))
            }
            aldServiceApi.findOrderProfitPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        orderProfitTask(){
            aldServiceApi.orderProfitTask().then(res => {
                if (res.result) {
                    this.handleSearch()
                    this.$message.success("结算完成");
                } else {
                    if(res.msg){
                        this.$message.error(res.msg);
                    }else{
                        this.$message.error("结算失败");
                    }
                }
            });
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['ID', '订单ID', '会员地址', 
            '结算日',"结算类型","结算状态","结算年化率",
            "总产出","自己获得","给直推","直推地址","给白名单","白名单地址","平台沉淀"];
            let columns = ['id','oid','memberAddress', 
            'createdAt', 'type','status', 'apy', 
            'total',"profitSelf","profitParent","parentAddress","profitLeader",'leaderAddress','profitExp'];
            let data = this.tableData.map(r => columns.map(c => {
                if(c == 'createdAt'){
                    return this.formatDate2(new Date(r[c]));
                }else{
                    let val = r[c];
                    return val;
                }   
            }));
            exportData2(header,data,"结算记录");
        }
    }
};
</script>

<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}
</style>